/*
	Centralize verbiage in the app with localization for other langues (future)
*/
app.addFeature(
	"lang",
	function(){
		"use strict";

		var lang = "EN_US",
			verbiage = {
				EN_US : {

				}
			};

		function get(verb,opts){
			return (verbiage[lang][verb] || "").assign(opts || {});
		}

		function setLang(l){
			lang = l;

			return this;
		}

		this.get = get;
		this.setLang = setLang;
	}
);
